<template>
  <div class="w3-container messageinbox" v-if="user && selecteddevice">
    <button v-if="!selectedphonenumber && !newunknown" @click="$router.push('devices')"  class="w3-button w3-border w3-round-xxlarge">&#171;&#171;</button>
    <button v-if="newunknown" @click="clear()"  class="w3-button w3-border w3-round-xxlarge">&#171;&#171;</button>
    <button v-if="selectedphonenumber" @click="clear()"  class="w3-button w3-border w3-round-xxlarge">&#171;&#171; {{selectedphonenumber|resolveContact}}</button>
    <button v-if="user && selecteddevice" @click="clearAndSyncMessages()" class="w3-button w3-border w3-round-xxlarge">Sync Inboxes</button>

    
    <p><button v-if="!newunknown && !selectedphonenumber" @click="newunknown=true" class="w3-button w3-block w3-border w3-round-xxlarge">Create New</button></p>

    <template v-if="messagesinbox && !selectedphonenumber && !newunknown">
      <ul class="w3-ul w3-panel w3-border w3-round-large">       
        <li v-for="(messages, keyPhone) in messagesinbox" :key="keyPhone">          
          <button @click="selectedphonenumber = keyPhone" class="w3-button w3-block w3-border w3-round-xxlarge">
            {{keyPhone|resolveContact}} ({{messages|countmessages}})</button>      
        </li>
      </ul>
    </template>

    <template v-if="selectedphonenumber && !newunknown" class="w3-display-container">
      
      <div class="w3-ul w3-panel w3-border w3-round-large">              

            <p>      
              <textarea class="w3-input w3-border" rows="3" style="resize:none" v-model="message"></textarea>              
            </p>
            <p>
              <button @click="createSendSMS(selectedphonenumber);" v-if="message" class="w3-button w3-border w3-round-xxlarge">Send</button>
            </p>           

            <div v-for="(groupeddates, keydate) in messagesinbox[selectedphonenumber]" :key="keydate">
                
                <span><strong>{{groupeddates.messagegroupingdate|formatEpochDateOnly}}</strong></span>
                <div v-for="(messageDetails, keymessagedate) in groupeddates.messages" :key="keymessagedate">
                    <!-- keymessagedate is not an actual date only used for sorting -->
                    <div v-bind:class="{'w3-display-container:true, triangle-isosceles right': messageDetails.type===2,'triangle-isosceles left': messageDetails.type===1 }">
                      <div>{{messageDetails.date| formatUnixTimeOnly}}</div>                          
                      <div>{{messageDetails.message}}</div> 

                      <span class="w3-display-bottomright delete">                  
                        <h1 @click="sendDeviceCommand({type:'deletemessage',info:messageDetails})">&times;</h1>
                      </span>
                    </div>                    
                </div>
            

            </div>
      </div>
    </template>

     <template v-if="newunknown && !selectedphonenumber" class="w3-display-container">      
        <div class="w3-ul w3-panel w3-border w3-round-large smsnew"> 
            <p>                        
              <input type="tel" class="w3-input w3-border" placeholder="Enter Number" style="resize:none" v-model="newnumber"/>
            </p>
            <p>      
              <textarea class="w3-input w3-border" rows="15" style="resize:none" v-model="message"></textarea>
            </p>
            <button @click="createSendSMS(newnumber);" v-if="message && newnumber" class="w3-button w3-border w3-round-xxlarge">Send</button>
        </div>
    </template>

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "MessagesInbox",
  filters: {
    countmessages: function (messagesdaygrouping) {
      let messagecount = 0;
      Object.keys(messagesdaygrouping).forEach((epochkey)=>{
            let epoch = messagesdaygrouping[epochkey]
            messagecount +=Object.keys(epoch.messages).length
      })
      return messagecount
    }
  },
  data() {
    return {
      selectedphonenumber: null,      
      newnumber:null,
      newunknown:null,
      msg: "Welcome to the MessagesInbox page",
      message:null
    };
  },
  beforeCreated() {},
  created: function() {},
  mounted() {},
  methods: {
    clear() {
      this.selectedphonenumber = null;      
      this.newnumber = null;     
      this.newunknown=null; 
      this.message = null;
    },
    createSendSMS(number) {
      this.sendSMS({too:number,message:this.message})
      this.message = null;
    }, 
    clearAndSyncMessages(){
        this.sendDeviceCommand({type:'RefreshInboxes'})
        this.clear();
    },
    ...mapActions(["sendSMS","sendDeviceCommand","setSelectedNumber"])
  },
  computed: {
    ...mapGetters(["user", "messagesinbox","selecteddevice"])
  },
  beforeDestroy() {},
  destroy() {
    this.selectedphonenumber = null;
    this.newnumber = null;
    this.newunknown=null;       
    this.message = null;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

.delete{
  padding-right: 10px;
}
.smsnew {
  padding-bottom: 10px;
}

.messageinbox {
  padding-top: 10px;
}

.messageinbox_order_lines {
  padding-top: 10px;
}

.w3-ul li {
  border-bottom: none;
}

.footer {
  padding-top: 10px;
}
/* ============================================================================================================================
== BUBBLE WITH AN ISOCELES TRIANGLE
** ============================================================================================================================ */

/* THE SPEECH BUBBLE
------------------------------------------------------------------------------------------------------------------------------- */

.triangle-isosceles {
  position: relative;
  padding: 15px;
  margin: 1em 0 3em;
  color: #000;
  background: #f3961c; /* default background for browsers without gradient support */
  /* css3 */
  background: -webkit-gradient(linear, 0 0, 0 100%, from(#f9d835), to(#f3961c));
  background: -moz-linear-gradient(#f9d835, #f3961c);
  background: -o-linear-gradient(#f9d835, #f3961c);
  background: linear-gradient(#f9d835, #f3961c);
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}

/* Variant : for top positioned triangle
------------------------------------------ */

.triangle-isosceles.top {
  background: -webkit-gradient(linear, 0 0, 0 100%, from(#f3961c), to(#f9d835));
  background: -moz-linear-gradient(#f3961c, #f9d835);
  background: -o-linear-gradient(#f3961c, #f9d835);
  background: linear-gradient(#f3961c, #f9d835);
}

/* Variant : for left/right positioned triangle
------------------------------------------ */

.triangle-isosceles.left {
  margin-right: 100px;
  margin-left: 50px;
  background: #f3961c;
}

/* Variant : for right positioned triangle
------------------------------------------ */

.triangle-isosceles.right {
  margin-right: 50px;
  margin-left: 100px;
  background: greenyellow;
}

/* THE TRIANGLE
------------------------------------------------------------------------------------------------------------------------------- */

/* creates triangle */
.triangle-isosceles:after {
  content: "";
  position: absolute;
  bottom: -15px; /* value = - border-top-width - border-bottom-width */
  left: 50px; /* controls horizontal position */
  border-width: 15px 15px 0; /* vary these values to change the angle of the vertex */
  border-style: solid;
  border-color: #f3961c transparent;
  /* reduce the damage in FF3.0 */
  display: block;
  width: 0;
}

/* Variant : top
------------------------------------------ */

.triangle-isosceles.top:after {
  top: -15px; /* value = - border-top-width - border-bottom-width */
  right: 50px; /* controls horizontal position */
  bottom: auto;
  left: auto;
  border-width: 0 15px 15px; /* vary these values to change the angle of the vertex */
  border-color: #f3961c transparent;
}

/* Variant : left
------------------------------------------ */

.triangle-isosceles.left:after {
  top: 16px; /* controls vertical position */
  left: -50px; /* value = - border-left-width - border-right-width */
  bottom: auto;
  border-width: 10px 50px 10px 0;
  border-color: transparent #f3961c;
}

/* Variant : right
------------------------------------------ */

.triangle-isosceles.right:after {
  top: 16px; /* controls vertical position */
  right: -50px; /* value = - border-left-width - border-right-width */
  bottom: auto;
  left: auto;
  border-width: 10px 0 10px 50px;
  border-color: transparent greenyellow;
}
</style>



// WEBPACK FOOTER //
// src/components/MessagesInbox.vue